export const reportAccountTypeMap = (value: any, reportEnum: any) => {

    const accountType: any = {
        [reportEnum.eSachkonten]: 2, 
        [reportEnum.ePersonenkonten]: 1, 
        [reportEnum.eKreditorkonten]: 3, 
        [reportEnum.eProjektkonten]: 4, 
        [reportEnum.eKostenstellenkonten]: 5, 
        [reportEnum.eAnlagekonten]: 7}
        
    return accountType[value]
}